// Copyright (c) 2016 Deere & Company

import MCCFollowupClaimContainer from '../../claim/marketing/mass-channel-customer-followup/state-connector';

export default {
    component: MCCFollowupClaimContainer,
    name: 'MARKETING_MASS_CHANNEL_FOLLOWUP',
    path: 'mcc-followup/edit/:claimNumber'
};



// WEBPACK FOOTER //
// ./src/routes/claims/edit-mass-channel-customer-followup-route.js